var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAuditorNoteDelete = function SvgAuditorNoteDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.786 12.444c0 .413.165.809.46 1.1A1.58 1.58 0 0 0 2.357 14h6.286a1.58 1.58 0 0 0 1.111-.456c.295-.291.46-.687.46-1.1V3.111H.786v9.333Zm1.571-7.777h6.286v7.777H2.357V4.667ZM8.25.777 7.464 0H3.536L2.75.778H0v1.555h11V.778H8.25Z",
    fill: "#757575"
  })));
};
export default SvgAuditorNoteDelete;